export enum USER_COMPETENCE_BO {
  DEPARTEMENTALE = "DEP",
  NATIONALE = "NAT",
  REGIONALE = "REG",
}

export enum USER_TYPE {
  BO = "BO-AGENT", // Back-office Agent
  FU = "FUSAGER-OVA", // Front-office Usager Organisme de Vacances
}

export const USER_TARGET = {
  BO: "bo",
  FO: "fo",
} as const;
